// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import * as yup from "yup";
import { useEffect, useState } from "react";
import { VisibilityOutlined, VisibilityOffOutlined } from "@mui/icons-material";
import useTranslation from "next-translate/useTranslation";
import { useMediaQuery, useTheme } from "@mui/material";
import Cookies from "js-cookie";

import { useStepperContext } from "@/hooks/useStepperContext";
import { Button, Form, Grid, Link, Typography, Dialog } from "@/components/core";
import { useUserInfoStore } from "@/store/login/user-info";
import { useLogOutStore } from "@/store/login/apply";

export function LogInEntrance() {
  const stepper = useStepperContext();
  const theme = useTheme();
  const { t } = useTranslation("login");
  const phoneNumber = Cookies.get("phone-number");
  const userInfo = useUserInfoStore((state: any) => state.userInfo);
  const logout = useLogOutStore((state: any) => state.logout);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [forgotUserPassOpen, setForgotUserPassOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (phoneNumber) {
      fetch("/api/logout", { method: "POST" }).then(() => logout());
    }
  }, []);
  const formProps = {
    initialValues: { userName: "", password: "" },
    validationSchema: yup.object({
      userName: yup.string().required(),
      password: yup.string().required(),
    }),
    onSubmit: async (loginData: any) => {
      setLoading(true);
      await userInfo(loginData, stepper);
      setLoading(false);
    },
  };

  return (
    <Form {...formProps}>
      <Grid
        spacing={3}
        sx={{
          width: "100%",
          maxWidth: 400,
          mt: { xs: 4, md: 8 },
          mx: "auto",
          "& .MuiGrid-item": { px: 0 },
        }}
      >
        <Grid.Item xs={12}>
          <Typography
            bold
            sx={{
              fontSize: 28,
              fontWeight: 600,
              mb: 2,
            }}
          >
            {t("corporate")}
          </Typography>
        </Grid.Item>
        <Grid.Item xs={12}>
          <Typography sx={{ mb: 1 }}>{t("userCode")}</Typography>
          <Form.TextField
            name="userName"
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                backgroundColor: "#f5f5f5",
              },
            }}
          />
        </Grid.Item>
        <Grid.Item xs={12}>
          <Typography sx={{ mb: 1 }}>{t("password")}</Typography>
          <Form.TextField
            name="password"
            type={passwordVisible ? "text" : "password"}
            fullWidth
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                backgroundColor: "#f5f5f5",
              },
            }}
            InputProps={{
              endAdornment: (
                <Button
                  onClick={() => setPasswordVisible((p) => !p)}
                  sx={{
                    minWidth: "auto",
                    p: 1,
                    color: "inherit",
                  }}
                >
                  {passwordVisible ? (
                    <VisibilityOffOutlined color="inherit" />
                  ) : (
                    <VisibilityOutlined color="inherit" />
                  )}
                </Button>
              ),
            }}
          />
        </Grid.Item>
        <Grid.Item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <Button
            sx={{
              color: theme.palette.secondary.main,
              px: 0,
              fontSize: 12,
              fontWeight: 700,
            }}
            onClick={() => setForgotUserPassOpen(true)}
          >
            {t("forgotUserPassword")}
          </Button>
        </Grid.Item>
        <Grid.Item xs={12}>
          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={loading}
            sx={{
              background: theme.palette.background.gradient,
              height: 48,
              borderRadius: 2,
              fontSize: 16,
              fontWeight: 600,
              width: "100%",
              color: theme.palette.background.alternate,
            }}
          >
            {loading ? t("loginin") : t("signIn")}
          </Button>
        </Grid.Item>
        <Grid.Item xs={12} sx={{}}>
          <Link
            href="/register"
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              fullWidth
              variant="text"
              sx={{
                color: theme.palette.secondary.main,
                height: 48,
                borderRadius: 2,
                fontSize: 16,
                textDecoration: "underline",
                letterSpacing: "0.5px",
              }}
            >
              {t("signUp")}
            </Button>
          </Link>
        </Grid.Item>
      </Grid>

      <Dialog
        open={forgotUserPassOpen}
        onClose={() => setForgotUserPassOpen(false)}
        title={t("forgotUserPassword")}
      >
        <Typography sx={{ textAlign: "center", mb: 3 }}>
          {t("forgotUserPasswordMessage")}
        </Typography>
        <Button fullWidth variant="contained" onClick={() => setForgotUserPassOpen(false)}>
          {t("close")}
        </Button>
      </Dialog>
    </Form>
  );
}
